import { EmptyStateRoot } from "./empty-state";
import { EmptyStateAction } from "./parts/view-action";
import { EmptyStateDescription } from "./parts/view-description";
import { EmptyStateIllustration } from "./parts/view-illustration";
import { EmptyStateTitle } from "./parts/view-title";

export type * from "./types-empty-state";
export { ListEmptyState } from "./parts/list";
export { resolveListEmptyKind, useListEmptyState } from "./parts/list/use-list";
export type {
  ListEmptyStateProps,
  UseListEmptyStateOptions,
  UseListEmptyStateResult,
} from "./parts/list/types-list";
export type { ListEmptyGender, ListEmptyKind } from "./parts/list/messages";

/** Estado vazio composable (`EmptyState.Root/Illustration/Title/Description/Action`). */
export const EmptyState = {
  Root: EmptyStateRoot,
  Illustration: EmptyStateIllustration,
  Title: EmptyStateTitle,
  Description: EmptyStateDescription,
  Action: EmptyStateAction,
};
